"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  ICON: {
    COLOR: 'greyMediumDark',
    SIZE: 'titleMedium',
    TYPE: 'Person'
  },
  INPUT: {
    DEFAULT_BORDER_COLOR: 'greyMedium',
    ACTIVE_BORDER_COLOR: 'secondaryBlue'
  },
  LABEL: {
    COLOR: 'greyMediumDark',
    TYPE: 'sub'
  },
  PLACEHOLDER: {
    COLOR: 'neutral',
    TYPE: 'default'
  },
  DROPDOWN_ICON: {
    COLOR: 'greyDark',
    FONT_SIZE: 'titleNormal',
    ICON: 'ExpandMoreIcon'
  },
  MOBILE_HEADER: {
    TITLE: {
      COLOR: 'neutral'
    },
    ICON: {
      COLOR: 'greyMediumDark',
      SIZE: 'titleMedium',
      TYPE: 'CloseIcon'
    }
  }
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;